import { colors } from "./constant";
import { getUniqueAvatarCombinations } from "./utils";

export class AvatarGenerator {
  private cache: Map<string, string>;

  constructor(private availableCombinations = getUniqueAvatarCombinations()) {
    this.cache = new Map();
  }

  private getAvailableRandomIndex() {
    if (this.availableCombinations.length === 0) {
      return NaN;
    }

    return Math.floor(Math.random() * this.availableCombinations.length);
  }

  private parseAvatarKey(avatar: string) {
    const [animal, color] = avatar.split("_");
    const colorHex = colors[color as keyof typeof colors];

    return {
      animal,
      color,
      colorHex,
      key: avatar,
    };
  }

  private findByIndex = (index: number) => {
    const avatar = this.availableCombinations.at(index);
    if (!avatar) return null;
    return this.parseAvatarKey(avatar);
  };

  private writeCache(
    id: string,
    newInstanceKey: string,
    indexToBeRemoved: number
  ) {
    this.cache.set(id, newInstanceKey);
    this.availableCombinations.splice(indexToBeRemoved, 1);
  }

  public getRandomAvatar(key: string) {
    if (this.cache.has(key)) {
      const cachedValue = this.cache.get(key);
      return this.parseAvatarKey(cachedValue as string);
    }

    const randomIndex = this.getAvailableRandomIndex();
    const randomInstance = this.findByIndex(randomIndex);

    if (!randomInstance) {
      return null;
    }

    this.writeCache(key, randomInstance.key, randomIndex);

    return randomInstance;
  }

  public reset() {
    this.cache.clear();
    this.availableCombinations = getUniqueAvatarCombinations();
  }
}
